/** Server presence / system frames for Answer or Bluff (see FRONTEND_ANSWER_BLUFF_WEBSOCKET.md). */

export type BluffRoster = Record<string, string>;

export type BluffPresenceEvent = {
  type: "presence";
  event: "joined_room" | "left_room";
  display_name: string;
  connection_id: string;
};

export type BluffSocketReadyEvent = {
  type: "system";
  event: "socket_ready";
  room_code?: string;
  connection_id: string;
};

export function parseBluffPresencePayload(raw: unknown): BluffPresenceEvent | null {
  if (!raw || typeof raw !== "object") return null;
  const o = raw as Record<string, unknown>;
  if (o.type !== "presence") return null;
  if (o.event !== "joined_room" && o.event !== "left_room") return null;
  const connection_id = typeof o.connection_id === "string" ? o.connection_id : "";
  if (!connection_id) return null;
  const display_name = typeof o.display_name === "string" && o.display_name.trim() ? o.display_name.trim() : "Guest";
  return { type: "presence", event: o.event, display_name, connection_id };
}

export function parseBluffSocketReadyPayload(raw: unknown): BluffSocketReadyEvent | null {
  if (!raw || typeof raw !== "object") return null;
  const o = raw as Record<string, unknown>;
  if (o.type !== "system" || o.event !== "socket_ready") return null;
  const connection_id = typeof o.connection_id === "string" ? o.connection_id : "";
  if (!connection_id) return null;
  return {
    type: "system",
    event: "socket_ready",
    room_code: typeof o.room_code === "string" ? o.room_code : undefined,
    connection_id,
  };
}

export function applyPresenceToRoster(roster: BluffRoster, msg: BluffPresenceEvent): BluffRoster {
  if (msg.event === "left_room") {
    const next = { ...roster };
    delete next[msg.connection_id];
    return next;
  }
  return { ...roster, [msg.connection_id]: msg.display_name };
}
